import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatStrikethroughIcon from '@mui/icons-material/FormatStrikethrough';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import Button from '@mui/material/Button';
import { Theme } from '@mui/material/styles';
import { EditorState } from 'draft-js';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        width: 'auto',
        minWidth: '32px',
        padding: '3px 6px',
        '& .MuiButton-startIcon': {
            margin: 0,
        },
        color: theme.palette.sidebarHeader.main,
        borderColor: theme.palette.sidebarHeader.main,
        '&:hover': {
            backgroundColor: theme.palette.btnDefault.light,
            borderColor: theme.palette.sidebarHeader.main,
        },
    },
    active: {
        backgroundColor: theme.palette.pageNavigationBar.main,
        color: theme.palette.secondary.contrastText,
        '&:hover': {
            color: theme.palette.sidebarHeader.main,
        },
    },
}));

export interface InlineStylesButtonProps {
    name: string;
    ariaLabel: string;
    value: 'BOLD' | 'ITALIC' | 'UNDERLINE' | 'STRIKETHROUGH';
}

interface Props {
    editorState: EditorState;
    config: InlineStylesButtonProps;
    isDisabled: boolean;
    onClickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function InlineStylesButton({
    editorState,
    config,
    isDisabled,
    onClickHandler,
}: Props) {
    const { classes, cx } = useStyles();

    const [icon, setIcon] = React.useState<any>(null);

    React.useEffect(() => {
        switch (config.value) {
            case 'BOLD':
                setIcon(<FormatBoldIcon />);
                break;
            case 'ITALIC':
                setIcon(<FormatItalicIcon />);
                break;
            case 'UNDERLINE':
                setIcon(<FormatUnderlinedIcon />);
                break;
            case 'STRIKETHROUGH':
                setIcon(<FormatStrikethroughIcon />);
                break;
            default:
                setIcon(null);
        }
    }, [config.value]);

    const isActive = editorState.getCurrentInlineStyle().has(config.value);

    return (
        <Button
            name={config.name}
            aria-label={config.ariaLabel}
            aria-pressed={isActive ? 'true' : 'false'}
            value={config.value}
            onMouseDown={onClickHandler}
            startIcon={icon}
            size="small"
            variant="outlined"
            disabled={isDisabled}
            className={cx(classes.root, isActive && classes.active)}
        ></Button>
    );
}
